import object from 'helpers/object'


export const initialState = {
  classes: [],
  schools: [],
  isFetching: true,
}

export const setFetching = (state, payload) => (
  object.setIn(state, [ 'isFetching' ], payload)
)

export const setClasses = (state, payload) => (
  object.setIn(state, [ 'classes' ], payload)
)

export const setSchools = (state, payload) => (
  object.setIn(state, [ 'schools' ], payload)
)

export const setSchool = (state, payload) => (
  object.setIn(state, [ 'school' ], payload)
)